// Core
import React from 'react'
import clsx from 'clsx'

// Components
import Sidebar from 'components/Sidebar'
import Header from 'components/Header'
import PageTemplate from 'pages/shared/PageTemplate'
import BulletList from 'components/Onboarding/BulletList/BulletList'
import BlockQuote from 'components/Onboarding/BlockQuote/BlockQuote'
import DataDisclaimer from 'components/Onboarding/DataDisclaimer'
import ConnectDataSources from 'components/Onboarding/ConnectDataSources'

// Styles
import classes from 'pages/Onboarding/Onboarding.module.scss'

export default function OnboardingConnectPage() {
  return (
    <div className="d-flex">
      <Sidebar isOpen={false} disabled />
      <div className="page-content">
        <Header />
        <PageTemplate>
          <div className={clsx(classes.connectWrapper)}>
            <div className={clsx(classes.connectSection)}>
              <h1 className={clsx(classes.connectTitle, 'fw-semibold')}>
                Lets get started
              </h1>
              <h2 className={clsx(classes.connectSubtitle, 'fw-semibold')}>
                Connect your advertising accounts
              </h2>
              <p className={clsx(classes.connectParagraph)}>
                Connect your ad accounts to unlock the full potential of EDEE
              </p>
              <DataDisclaimer />
              <div className={clsx(classes.connectContainer, 'mt-4')}>
                <ConnectDataSources />
              </div>
            </div>
            <div
              className={clsx(
                classes.infoContainer,
                classes.infoConnectContainer
              )}
            >
              <div className={clsx(classes.infoSection)}>
                <h2 className="fw-semibold">Unlock the full power of EDEE</h2>
              </div>
              <div className={clsx(classes.infoSection, 'mt-2')}>
                <BulletList
                  features={[
                    'Automated budget management software with OptiPacer',
                    'Prevent campaign overspend with alerts & automations',
                    'Track performance vs. KPIs',
                    'Manage multiple platforms in one place',
                    'Save hours on manual budget management',
                  ]}
                />
              </div>
              <div className={clsx(classes.infoSection, 'mt-8')}>
                <BlockQuote
                  quote="The platform is very easy to use and, in case of any problem, the team is ready to help you right away."
                  author="Cristina S. - PPC Manager"
                />
              </div>
              <div className={clsx(classes.infoSection, 'mt-2', 'mb-4')}>
                <h4 className="fw-semibold">Thousands of budgets managed</h4>
              </div>
            </div>
          </div>
        </PageTemplate>
      </div>
    </div>
  )
}
